import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import AnnouncementBanner from './AnnouncementBanner';
import Footer from './Footer';
import SkipLink from '../common/SkipLink';
import styles from './MainLayout.module.css';

const MainLayout: React.FC = () => {
  return (
    <div className={styles.layout}>
      <SkipLink />
      <AnnouncementBanner />
      <Header />
      <main
        id="main-content"
        tabIndex={-1}
        className={styles.mainContent}
        style={{ outline: 'none' }}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
